
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 70.886 90.365"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 291","fill":"none","stroke":"#707070","stroke-miterlimit":"10","stroke-width":"3.5"}},[_c('path',{attrs:{"data-name":"Rectangle 184","d":"M8.53 19.793h54.218v51.844a16.979 16.979 0 01-16.979 16.978H25.488A16.977 16.977 0 018.526 71.637V19.793z"}}),_c('path',{attrs:{"data-name":"Path 550","d":"M69.136 14.45a5.353 5.353 0 01-5.354 5.352H7.47a5.351 5.351 0 01-.733-10.677 5.252 5.252 0 01.733 0h56.312a5.338 5.338 0 015.354 5.317z"}}),_c('path',{attrs:{"data-name":"Path 551","d":"M47.725 7.102a5.448 5.448 0 01-.385 2.008H23.96a5.448 5.448 0 01-.385-2.008 5.352 5.352 0 015.351-5.352h13.466a5.352 5.352 0 015.333 5.352z"}}),_c('g',{attrs:{"data-name":"Group 290","stroke-linecap":"round"}},[_c('path',{attrs:{"data-name":"Line 35","d":"M48.806 31.003v43.012"}}),_c('path',{attrs:{"data-name":"Line 36","d":"M35.641 31.003v43.012"}}),_c('path',{attrs:{"data-name":"Line 37","d":"M22.477 31.003v43.012"}})])])])
          )
        }
      }
    